export var ServiceEndpointExecutionHistoryListColumnKeys = {
    Result: "result",
    Type: "type",
    Definition: "definition",
    Name: "name",
    StartTime: "startTime",
    FinishTime: "finishTime"
};